import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { DocumentsComponent } from "./documents.component";
import { AuthGuardService as authGuard } from "app/auth-guard.service";
import { DocumentUploadComponent } from "./document-upload/document-upload.component";

const routes: Routes = [
  {
    path: 'documentnew',
    component: DocumentsComponent,
    canActivate: [authGuard]
  },
  {
    path: 'documentnew/upload/:groupId',
    component: DocumentUploadComponent,
    canActivate: [authGuard]
  },
  {
    path: 'documentnew/:groupId',
    component: DocumentsComponent,
    canActivate: [authGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DocumentsRoutingModule { }
